<template>

  <div class="padded">


    <h3>Backhaul Provider Summary</h3></br />
    <br />

    <pie-chart
    :data="chartSites"
    thousands=","
    legend="right"
    :colors="colours"
    :download="true" />

    <hr />

    <el-table
       :data="summary"
       border
       stripe
       show-summary
       sum-text="Totals"
       :summary-method="summaryFormatter"
       style="width: 100%">

       <el-table-column prop="provider"
        label="Provider">
       </el-table-column>

       <el-table-column prop="siteStatus"
        label="Site Status">
       </el-table-column>

       <el-table-column prop="backhaulType"
        label="Type">
       </el-table-column>

       <el-table-column prop="backhaulStatus"
        label="B/Status">
       </el-table-column>

       <el-table-column prop="sites"
       label="Sites"
        sortable
        align="right"
        :formatter="formatInt">
       </el-table-column>

       <el-table-column
          prop="entranceFee"
          label="Entrance Fee"
          sortable
          align="right"
          :formatter="formatNum">
       </el-table-column>

       <el-table-column
          prop="rowFee"
          label="ROW Fee"
          sortable
          align="right"
          :formatter="formatNum">
       </el-table-column>

       <el-table-column prop="customers"
       label="Customers"
        sortable
        align="right"
        :formatter="formatInt">
       </el-table-column>

       <el-table-column
          prop="customerEntranceFee"
          label="Cust. Ent. Fee"
          sortable
          align="right"
          :formatter="formatNum">
       </el-table-column>

       <el-table-column
          prop="customerRowFee"
          label="Cust. ROW Fee"
          sortable
          align="right"
          :formatter="formatNum">
       </el-table-column>
     </el-table>

  </div>
</template>

<script>

import {chartColors} from '@/components/Data'

import PostMixins from '@/mixins/PostMixins'
import ElTableMixins from '@/mixins/ElTableMixins'
import NumberMixins from '@/mixins/NumberMixins'

export default {
  mixins: [PostMixins, ElTableMixins, NumberMixins],

  methods: {
    summaryData (data) {
      this.summary = data

      if (this.summary && this.summary.length > 0) {

        for (var i = 0; i < this.summary.length; i++) {

          let label = this.summary[i].siteStatus + ' (' + this.summary[i].provider + ': ' + this.summary[i].backhaulType + ')'

          this.chartSites.push([label, Number(Number(this.summary[i].sites).toFixed(2))])
        }

      }

    },

    summaryFormatter (param) {
      return this.totalColumns(param, 'Totals', ['sites', 'customers'], ['entranceFee', 'rowFee', 'customerEntranceFee', 'customerRowFee'])
    }

  },

  data () {
    return {
      summary: [],
      chartSites: [],
      colours: chartColors
    }
  },

  created () {
    this.fetchData('report/backhaul/summary' + (this.org() && this.org().id && this.org().category === 'Backhaul' ? '/' + this.org().id : ''), this.summaryData, 'Backhaul Summary')
  }
}
</script>
